// 관세사 보완요청 인박스 (업체) — 관세사가 반려한 의뢰 확인 + 보완 후 재전송 (2026-05-28)
//   백엔드: GET /clearance/my-revisions, POST /clearance/:id/supplement(첨부 누적), POST /clearance/:id/resubmit(전송)
//   ⚠️ 인보이스 재작성 X. 첨부파일은 다른 폴더 것도 하나씩 누적 → '보완 완료 재전송'으로 한 번에 관세사 전달.
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { API, authFetch } from '../utils/api';
import { getSocket } from '../utils/socket';

var NAVY = '#1B3A5C';
var CAT_COLOR = { '사진부족': '#ea580c', '정보부족': '#2563eb', '기타': '#64748b' };

function ClearanceRevisionInbox({ showToast, user }) {
  var st = showToast || function () {};
  var navigate = useNavigate();
  var itemsState = useState([]); var items = itemsState[0]; var setItems = itemsState[1];
  var loadingState = useState(true); var loading = loadingState[0]; var setLoading = loadingState[1];
  var uploadingState = useState(0); var uploadingId = uploadingState[0]; var setUploadingId = uploadingState[1]; // 업로드 중인 의뢰 id

  function load() {
    authFetch(API + '/clearance/my-revisions').then(function (r) { return r.json(); })
      .then(function (d) { if (d && d.success) setItems(d.items || []); setLoading(false); })
      .catch(function () { setLoading(false); });
  }
  useEffect(function () { load(); }, []);
  // 실시간 — 관세사 보완요청 도착 시 갱신
  useEffect(function () {
    var sock = getSocket(); if (!sock) return;
    function onRev() { load(); }
    sock.on('clearance:revision-requested', onRev);
    return function () { try { sock.off('clearance:revision-requested', onRev); } catch (e) {} };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function goCar(carNo) { navigate('/main/car-list', { state: { search: carNo } }); }
  // 부족 파일(쇼링리스트 등) 첨부 — 누적만(전송 X). 다른 폴더 것도 하나씩 여러 번 추가 가능.
  function uploadSupplement(it, fileList) {
    var files = Array.prototype.slice.call(fileList || []);
    if (files.length === 0 || uploadingId) return;
    setUploadingId(it.id);
    var fd = new FormData();
    files.forEach(function (f) { fd.append('files', f); });
    authFetch(API + '/clearance/' + it.id + '/supplement', { method: 'POST', body: fd })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        setUploadingId(0);
        if (d && d.success) {
          st('파일 ' + (d.added || files.length) + '개 첨부됨 (총 ' + (d.totalFiles || 0) + '개) — 재전송 시 관세사로 전달', '');
          setItems(function (prev) { return prev.map(function (x) { return x.id === it.id ? Object.assign({}, x, { files: d.files || x.files }) : x; }); });
        } else st((d && d.error) || '파일 첨부 실패', 'err');
      }).catch(function () { setUploadingId(0); st('파일 첨부 실패', 'err'); });
  }
  function resubmit(it) {
    if (uploadingId === it.id) { st('첨부 완료를 기다려주세요', 'err'); return; } // 첨부 in-flight 중 전송 차단 (race: 대기 전환 후 첨부 400 드롭)
    var n = (it.files && it.files.length) || 0;
    var msg = it.carNo + ' — 보완을 완료하고 관세사에 재전송할까요?' + (n > 0 ? ' (첨부 ' + n + '개 동반)' : ' (차량에 부족분 또는 첨부파일을 먼저 추가하세요)');
    if (!window.confirm(msg)) return;
    authFetch(API + '/clearance/' + it.id + '/resubmit', { method: 'POST' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.success) { st('재전송됨 — 관세사가 재확인합니다', ''); setItems(function (prev) { return prev.filter(function (x) { return x.id !== it.id; }); }); }
        else st((d && d.error) || '재전송 실패', 'err');
      }).catch(function () { st('재전송 실패', 'err'); });
  }

  return (
    <div style={{ padding: '20px 24px', maxWidth: 1000, margin: '0 auto' }}>
      <div style={{ fontSize: 22, fontWeight: 800, color: NAVY, marginBottom: 4 }}>{'🔴 관세사 보완 요청'}</div>
      <div style={{ fontSize: 12, color: '#64748b', marginBottom: 6 }}>{'관세사가 면장 처리에 필요한 보완을 요청한 건입니다. (인보이스 재작성 불필요)'}</div>
      <div style={{ fontSize: 12, color: '#64748b', marginBottom: 20, lineHeight: 1.6 }}>
        {'• 차량 사진/정보 보완: '}<b>{'차량으로 이동'}</b>{' → 추가'}<br />
        {'• 쇼링리스트 등 첨부파일: '}<b style={{ color: '#1d4ed8' }}>{'📎 파일 첨부'}</b>{' (다른 폴더 파일도 하나씩 여러 번 추가 가능 — 누적됨)'}<br />
        {'• 모두 준비되면 '}<b style={{ color: '#16a34a' }}>{'보완 완료 재전송'}</b>{' → 첨부파일과 함께 관세사로 전달'}</div>

      {loading && <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>{'불러오는 중...'}</div>}
      {!loading && items.length === 0 && (
        <div style={{ padding: 50, textAlign: 'center', color: '#94a3b8', background: '#fff', borderRadius: 12, border: '1px solid #e5e7eb' }}>
          <div style={{ fontSize: 32, opacity: 0.4 }}>{'✅'}</div>
          <div style={{ marginTop: 8 }}>{'보완 요청이 없습니다'}</div>
        </div>
      )}
      {!loading && items.map(function (it) {
        var catColor = CAT_COLOR[it.revision_category] || '#64748b';
        return (
          <div key={it.id} style={{ background: '#fff', border: '1px solid #fecaca', borderLeft: '4px solid #dc2626', borderRadius: 10, padding: '14px 18px', marginBottom: 10 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, flexWrap: 'wrap' }}>
              <div style={{ flex: 1, minWidth: 200 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                  <span style={{ fontSize: 16, fontWeight: 800, color: NAVY }}>{it.carNo}</span>
                  <span style={{ fontSize: 12, color: '#64748b' }}>{it.carType}</span>
                  {it.revision_category && <span style={{ fontSize: 11, fontWeight: 700, color: '#fff', background: catColor, borderRadius: 10, padding: '2px 8px' }}>{it.revision_category}</span>}
                </div>
                <div style={{ fontSize: 12, color: '#64748b' }}>{'관세사: ' + (it.agencyName || '-') + '  ·  요청일: ' + (it.requestDate || '-')}</div>
                {it.memo && <div style={{ fontSize: 13, color: '#7f1d1d', background: '#fef2f2', borderRadius: 6, padding: '8px 10px', marginTop: 8 }}>{'📝 ' + it.memo}</div>}
                {it.files && it.files.length > 0 && (
                  <div style={{ marginTop: 8, display: 'flex', flexWrap: 'wrap', gap: 6, alignItems: 'center' }}>
                    <span style={{ fontSize: 11, color: '#16a34a', fontWeight: 700 }}>{'첨부 ' + it.files.length + '개:'}</span>
                    {it.files.map(function (f) {
                      return <span key={f.id} title={f.originalName} style={{ fontSize: 11, color: '#1d4ed8', background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 6, padding: '3px 8px', maxWidth: 220, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{'📎 ' + f.originalName}</span>;
                    })}
                  </div>
                )}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                <button onClick={function () { goCar(it.carNo); }} style={{ padding: '8px 14px', background: '#f1f5f9', color: NAVY, border: '1px solid #cbd5e1', borderRadius: 8, fontSize: 12, fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap' }}>{'차량으로 이동'}</button>
                <input id={'supfile-' + it.id} type="file" multiple style={{ display: 'none' }} onChange={function (e) { uploadSupplement(it, e.target.files); e.target.value = ''; }} />
                <label htmlFor={'supfile-' + it.id} style={{ padding: '8px 14px', background: uploadingId === it.id ? '#93c5fd' : '#2563eb', color: '#fff', borderRadius: 8, fontSize: 12, fontWeight: 700, cursor: uploadingId === it.id ? 'default' : 'pointer', whiteSpace: 'nowrap', textAlign: 'center' }}>{uploadingId === it.id ? '첨부 중...' : '📎 파일 첨부'}</label>
                <button onClick={function () { resubmit(it); }} disabled={uploadingId === it.id} style={{ padding: '8px 14px', background: uploadingId === it.id ? '#86efac' : '#16a34a', color: '#fff', border: 'none', borderRadius: 8, fontSize: 12, fontWeight: 700, cursor: uploadingId === it.id ? 'not-allowed' : 'pointer', whiteSpace: 'nowrap' }}>{'보완 완료 재전송'}</button>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default ClearanceRevisionInbox;
